import React from 'react';
import ReactDOM from 'react-dom/client';
import i18n from 'locales/i18n';
import { I18nextProvider } from 'react-i18next';
import App from 'App';
import reportWebVitals from 'reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { AuthProvider } from 'routes/AuthContext';
import { TooltipProvider } from "components/UI/Tooltip";
import { ConfirmationDialogProvider } from "components/ConfirmDialog/ConfirmationDialogProvider";
// import * as serviceWorker from 'serviceWorker';
import 'react-toastify/dist/ReactToastify.css';

import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <I18nextProvider i18n={i18n}>
        <TooltipProvider>
          <ConfirmationDialogProvider>
          <BrowserRouter>
            <React.StrictMode>
              <AuthProvider>
                <App />
              </AuthProvider>
            </React.StrictMode>
          </BrowserRouter>
          </ConfirmationDialogProvider>
        </TooltipProvider>
      </I18nextProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
